module.exports = __webpack_public_path__ + "static/media/iconProjects.c756e266.svg";